// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offcanvas {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  z-index: 1111;
}

.payout-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.payout-upload-text {
  font-size: 13px;
  color: #555;
}

.payout-actions {
  display: flex;
  align-self: self-end;
  margin-top: 5px;
}

.payout-disable-btn {
  padding: 5px 10px;
  border: 1px solid grey;
  border-radius: 5px;
  color: #000000;
}

.payout-disable-btn:hover {
  background-color: #aaa !important;
}

.payout-delete-btn {
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.payout-delete-btn:hover {
  color: red;
}

.custom-toast-container {
  position: relative !important;
  z-index: 9999 !important;
}

.payout-upload-text {
  font-size: 13px;
}

.card-title {
  font-size: 15px;
}

#playouts_listings_indexs {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: -10px;
}

#playouts_listings_indexs .card {
  cursor: pointer;
  justify-content: space-between;
  height: 100%;
  margin-bottom: 0px;
}

.individual_playout:hover {
  transform: scale(1.02);
  transition: transform 0.3s ease;
}

.individual_playout {
  width: calc(33.33% - 20px);
  margin: 10px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

@media (max-width: 768px) {
  .individual_playout {
    width: calc(50% - 20px);
  }
}

@media (max-width: 480px) {
  .individual_playout {
    width: 100% !important;
  }
}


.tv-custom-fade-modal .modal-content {
  background-color: rgba(255, 255, 255, 0.95);
  /* soft transparent modal */
}

/* Custom backdrop: you need to use additional logic to target just your modal if needed */
.tv-custom-fade-modal-backdrop {
  background-color: rgba(0, 0, 0, 0.2);
}

.offcanvas.offcanvas-end.show{z-index: 1111;}
.w-45{width: 45% !important;}
.individual_playout{width: calc((100% - (3*20px))/3);margin: 10px;overflow: hidden;position: relative; padding: 15px 30px;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;border-radius: 8px;}
#status_btn{ padding: 5px 10px; border: 1px solid grey; border-radius: 5px;cursor: pointer;}
#destroy_btn{padding: 5px 0px 5px 10px;cursor: pointer;}
#destroy_btn:hover{color: red;cursor: pointer;}
.custom-border-bottom{border-bottom: 2px solid rgb(245, 247, 252) !important;}
.individual_playout_list_img{height: 50px; width: 50px; object-fit: cover; border-radius: 5px;}
.individual_playout[draggable], .individual_playout_list[draggable]{cursor: grab;}
.individual_playout[draggable]:active, .individual_playout_list[draggable]:active{cursor: grabbing; opacity: 0.6;}
.playout-order-badge{display: inline-flex; align-items: center; justify-content: center; min-width: 28px; height: 28px; background: #e9ecef; border-radius: 50%; font-size: 12px; font-weight: 600; color: #495057; flex-shrink: 0;}
.playout-title-row{display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 6px;}
.playout-title-row-list{align-items: center;}
.playout-title-text{flex: 1 1; min-width: 0;}
.playout-title-text h5{white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
.playout-stream-summary{margin-top: 12px; padding-top: 12px; border-top: 1px solid #edf1f5;}
.playout-stream-status{display: inline-flex; align-items: center; justify-content: center; gap: 6px; border-radius: 999px; padding: 5px 10px; font-size: 12px; font-weight: 600; line-height: 1; white-space: nowrap; flex-shrink: 0;}
.playout-stream-status-dot{width: 8px; height: 8px; border-radius: 50%; background: currentColor; display: inline-block; position: relative; flex-shrink: 0;}
.stream-status-live{background: #dcfce7; color: #15803d; box-shadow: inset 0 0 0 1px rgba(21, 128, 61, 0.08);}
.stream-status-live .playout-stream-status-dot{animation: livePulse 1.4s ease-in-out infinite;}
.stream-status-scheduled{background: #fef3c7; color: #b45309; box-shadow: inset 0 0 0 1px rgba(180, 83, 9, 0.08);}
.stream-status-scheduled .playout-stream-status-dot{background: transparent; border: 2px solid currentColor;}
.stream-status-offline{background: #e5e7eb; color: #4b5563; box-shadow: inset 0 0 0 1px rgba(75, 85, 99, 0.08);}
.stream-status-offline .playout-stream-status-dot{opacity: 0.75;}
.playout-stream-row{display: flex; align-items: flex-start; gap: 10px; margin-bottom: 8px; min-width: 0;}
.playout-stream-row:last-child{margin-bottom: 0;}
.playout-stream-label{min-width: 42px; font-size: 12px; font-weight: 600; color: #6c757d; text-transform: uppercase; letter-spacing: 0.03em;}
.playout-stream-value{font-size: 13px; color: #212529; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1 1; min-width: 0; display: block;}

/* Premium Search UI */
.search-container {
    position: relative;
    display: flex;
    align-items: center;
    background: #fdfdfd;
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 0 12px;
    transition: all 0.3s ease;
    height: 42px;
}

.search-container:focus-within {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
    background: #fff;
}

.search-icon {
    color: #adb5bd;
    margin-right: 10px;
    font-size: 14px;
}

.search-input {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    width: 100%;
    outline: none !important;
    font-size: 14px;
    color: #212529;
}

.search-input::placeholder {
    color: #adb5bd;
    font-weight: 400;
}

.search-input::-webkit-search-cancel-button {
    -webkit-appearance: none;
}

@keyframes livePulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(21, 128, 61, 0.45);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 7px rgba(21, 128, 61, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(21, 128, 61, 0);
  }
}

@media (max-width: 768px) {
  .playout-title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .playout-title-text {
    width: 100%;
  }

  .playout-title-text h5 {
    white-space: normal;
  }

  .playout-stream-row {
    flex-direction: column;
    gap: 4px;
  }

  .playout-stream-label {
    min-width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Tv_Playout/Tvplayouts.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,0FAA0F;AAC1F;EACE,oCAAoC;AACtC;;AAEA,8BAA8B,aAAa,CAAC;AAC5C,MAAM,qBAAqB,CAAC;AAC5B,oBAAoB,gCAAgC,CAAC,YAAY,CAAC,gBAAgB,CAAC,kBAAkB,EAAE,kBAAkB,CAAC,oDAAoD,CAAC,kBAAkB,CAAC;AAClM,aAAa,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,CAAC,eAAe,CAAC;AAC3F,aAAa,yBAAyB,CAAC,eAAe,CAAC;AACvD,mBAAmB,UAAU,CAAC,eAAe,CAAC;AAC9C,sBAAsB,sDAAsD,CAAC;AAC7E,6BAA6B,YAAY,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,CAAC;AAC9F,oEAAoE,YAAY,CAAC;AACjF,kFAAkF,gBAAgB,EAAE,YAAY,CAAC;AACjH,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,CAAC;AACnO,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,CAAC;AACzH,wBAAwB,mBAAmB,CAAC;AAC5C,oBAAoB,SAAO,EAAE,YAAY,CAAC;AAC1C,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,CAAC;AACtF,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,CAAC;AAC3F,uBAAuB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,cAAc,CAAC;AACrO,2BAA2B,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE,cAAc,CAAC;AAC5J,oBAAoB,mBAAmB,EAAE,cAAc,EAAE,mDAAmD,CAAC;AAC7G,+CAA+C,8CAA8C,CAAC;AAC9F,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,kDAAkD,CAAC;AACjH,oDAAoD,uBAAuB,EAAE,8BAA8B,CAAC;AAC5G,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,kDAAkD,CAAC;AAC/G,kDAAkD,aAAa,CAAC;AAChE,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,kBAAkB,EAAE,YAAY,CAAC;AACxG,+BAA+B,gBAAgB,CAAC;AAChD,sBAAsB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,yBAAyB,EAAE,sBAAsB,CAAC;AAC5I,sBAAsB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,SAAO,EAAE,YAAY,EAAE,cAAc,CAAC;;AAE/K,sBAAsB;AACtB;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,qBAAqB;IACrB,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;EACE;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;EACA;IACE,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".offcanvas {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  z-index: 1111;\n}\n\n.payout-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.payout-upload-text {\n  font-size: 13px;\n  color: #555;\n}\n\n.payout-actions {\n  display: flex;\n  align-self: self-end;\n  margin-top: 5px;\n}\n\n.payout-disable-btn {\n  padding: 5px 10px;\n  border: 1px solid grey;\n  border-radius: 5px;\n  color: #000000;\n}\n\n.payout-disable-btn:hover {\n  background-color: #aaa !important;\n}\n\n.payout-delete-btn {\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.payout-delete-btn:hover {\n  color: red;\n}\n\n.custom-toast-container {\n  position: relative !important;\n  z-index: 9999 !important;\n}\n\n.payout-upload-text {\n  font-size: 13px;\n}\n\n.card-title {\n  font-size: 15px;\n}\n\n#playouts_listings_indexs {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin: -10px;\n}\n\n#playouts_listings_indexs .card {\n  cursor: pointer;\n  justify-content: space-between;\n  height: 100%;\n  margin-bottom: 0px;\n}\n\n.individual_playout:hover {\n  transform: scale(1.02);\n  transition: transform 0.3s ease;\n}\n\n.individual_playout {\n  width: calc(33.33% - 20px);\n  margin: 10px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n@media (max-width: 768px) {\n  .individual_playout {\n    width: calc(50% - 20px);\n  }\n}\n\n@media (max-width: 480px) {\n  .individual_playout {\n    width: 100% !important;\n  }\n}\n\n\n.tv-custom-fade-modal .modal-content {\n  background-color: rgba(255, 255, 255, 0.95);\n  /* soft transparent modal */\n}\n\n/* Custom backdrop: you need to use additional logic to target just your modal if needed */\n.tv-custom-fade-modal-backdrop {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.offcanvas.offcanvas-end.show{z-index: 1111;}\n.w-45{width: 45% !important;}\n.individual_playout{width: calc((100% - (3*20px))/3);margin: 10px;overflow: hidden;position: relative; padding: 15px 30px;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;border-radius: 8px;}\n#status_btn{ padding: 5px 10px; border: 1px solid grey; border-radius: 5px;cursor: pointer;}\n#destroy_btn{padding: 5px 0px 5px 10px;cursor: pointer;}\n#destroy_btn:hover{color: red;cursor: pointer;}\n.custom-border-bottom{border-bottom: 2px solid rgb(245, 247, 252) !important;}\n.individual_playout_list_img{height: 50px; width: 50px; object-fit: cover; border-radius: 5px;}\n.individual_playout[draggable], .individual_playout_list[draggable]{cursor: grab;}\n.individual_playout[draggable]:active, .individual_playout_list[draggable]:active{cursor: grabbing; opacity: 0.6;}\n.playout-order-badge{display: inline-flex; align-items: center; justify-content: center; min-width: 28px; height: 28px; background: #e9ecef; border-radius: 50%; font-size: 12px; font-weight: 600; color: #495057; flex-shrink: 0;}\n.playout-title-row{display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 6px;}\n.playout-title-row-list{align-items: center;}\n.playout-title-text{flex: 1; min-width: 0;}\n.playout-title-text h5{white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}\n.playout-stream-summary{margin-top: 12px; padding-top: 12px; border-top: 1px solid #edf1f5;}\n.playout-stream-status{display: inline-flex; align-items: center; justify-content: center; gap: 6px; border-radius: 999px; padding: 5px 10px; font-size: 12px; font-weight: 600; line-height: 1; white-space: nowrap; flex-shrink: 0;}\n.playout-stream-status-dot{width: 8px; height: 8px; border-radius: 50%; background: currentColor; display: inline-block; position: relative; flex-shrink: 0;}\n.stream-status-live{background: #dcfce7; color: #15803d; box-shadow: inset 0 0 0 1px rgba(21, 128, 61, 0.08);}\n.stream-status-live .playout-stream-status-dot{animation: livePulse 1.4s ease-in-out infinite;}\n.stream-status-scheduled{background: #fef3c7; color: #b45309; box-shadow: inset 0 0 0 1px rgba(180, 83, 9, 0.08);}\n.stream-status-scheduled .playout-stream-status-dot{background: transparent; border: 2px solid currentColor;}\n.stream-status-offline{background: #e5e7eb; color: #4b5563; box-shadow: inset 0 0 0 1px rgba(75, 85, 99, 0.08);}\n.stream-status-offline .playout-stream-status-dot{opacity: 0.75;}\n.playout-stream-row{display: flex; align-items: flex-start; gap: 10px; margin-bottom: 8px; min-width: 0;}\n.playout-stream-row:last-child{margin-bottom: 0;}\n.playout-stream-label{min-width: 42px; font-size: 12px; font-weight: 600; color: #6c757d; text-transform: uppercase; letter-spacing: 0.03em;}\n.playout-stream-value{font-size: 13px; color: #212529; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; min-width: 0; display: block;}\n\n/* Premium Search UI */\n.search-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    background: #fdfdfd;\n    border: 1px solid #ced4da;\n    border-radius: 8px;\n    padding: 0 12px;\n    transition: all 0.3s ease;\n    height: 42px;\n}\n\n.search-container:focus-within {\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n    background: #fff;\n}\n\n.search-icon {\n    color: #adb5bd;\n    margin-right: 10px;\n    font-size: 14px;\n}\n\n.search-input {\n    border: none !important;\n    background: transparent !important;\n    padding: 0 !important;\n    width: 100%;\n    outline: none !important;\n    font-size: 14px;\n    color: #212529;\n}\n\n.search-input::placeholder {\n    color: #adb5bd;\n    font-weight: 400;\n}\n\n.search-input::-webkit-search-cancel-button {\n    -webkit-appearance: none;\n}\n\n@keyframes livePulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(21, 128, 61, 0.45);\n  }\n  70% {\n    transform: scale(1.05);\n    box-shadow: 0 0 0 7px rgba(21, 128, 61, 0);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(21, 128, 61, 0);\n  }\n}\n\n@media (max-width: 768px) {\n  .playout-title-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .playout-title-text {\n    width: 100%;\n  }\n\n  .playout-title-text h5 {\n    white-space: normal;\n  }\n\n  .playout-stream-row {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .playout-stream-label {\n    min-width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
